import React, {FC} from 'react';
import dots_svg from '../assets/images/icons/dots.svg';
import {ReactSVG} from "react-svg";

interface Props {
  children: any;
  icon?: any;
}

const ModalDropdown: FC<Props> = ({children, icon}) => {
  return (
      <div className='modal-dropdown'>
        <div className="modal-dropdown-content">
          <ReactSVG src={icon || dots_svg} className='react-icon' />
        </div>
        <div className="modal-dropdown-hidden">
          {children}
        </div>
      </div>
  );
}

export default ModalDropdown;